import { createFileRoute } from '@tanstack/react-router';
import { seedsListOptions, toSeedsQuery } from '@/features/seeds/api';
import { SeedsPage } from '@/features/seeds/SeedsPage';
import { marketsQueryOptions, readStoredMarket, resolveMarketId } from '@/lib/market';
import { SEEDS_SEARCH_DEFAULTS, SeedsSearch, stripDefaults } from '@/lib/search-schemas';

export const Route = createFileRoute('/_auth/seeds/')({
  validateSearch: SeedsSearch,
  search: { middlewares: [stripDefaults(SeedsSearch, SEEDS_SEARCH_DEFAULTS)] },
  loaderDeps: ({ search }) => search,
  // Préchargement : les erreurs sont laissées à `useQuery` dans la page (`ErrorState` avec « Réessayer »).
  loader: async ({ context, deps }) => {
    const markets = await context.queryClient
      .ensureQueryData(marketsQueryOptions())
      .catch(() => undefined);
    const marketId = resolveMarketId({
      fromSearch: deps.market,
      stored: readStoredMarket(),
      markets,
    });
    if (!marketId) return;
    await context.queryClient
      .ensureQueryData(seedsListOptions(toSeedsQuery(deps, marketId)))
      .catch(() => undefined);
  },
  component: SeedsPage,
});
